import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { DocumentsSearchContent } from './components/DocumentsSearchContent';

export default function DocumentsSearch() {
    return (
        <MainContent
            component={<DocumentsSearchContent />}
            titulo='Consulta Documentos'
            noBackground
            tableMaxWidth
        />
    );

};
